export default (user, { can, cannot, rules }) => {
  if (user.hasRole("yitUser")) {
    can("manage", "iot-devices");
  }
}